"use client";

import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { NewsletterQuery } from "@packages/lib/graphQL/article-landing";
import { graphQlFetchFunction } from "@packages/lib/server-actions/server-action";
const Subscribe = dynamic(() => import("./subscribe"), { ssr: false });
const SubscribeComponent = ({
  iscontentPreview,
  category,
  subCategory,
  pageGrouping,
}: any) => {

  const [data, setData] = useState<any>(null);
  
    const isWhatuni = process.env.PROJECT==='Whatuni'
    if(!isWhatuni){
      return null;
    }  
  useEffect(() => {
    const fetchData = async () => {
      const query = NewsletterQuery(
        iscontentPreview,
        "Newsletter subscription - Whatuni"
      );
      const result = await graphQlFetchFunction(query, iscontentPreview);
      const jsondata = result?.data?.newsLetterData?.items?.[0];
      setData(jsondata);
    };
    fetchData();
  }, [iscontentPreview]);

  if (!data) return null;

  return (
    <Subscribe
      data={data}
      isPreviewTrue={iscontentPreview}
      category={category}
      subCategory={subCategory}
      pageGrouping={pageGrouping}
    />
  );
};

export default SubscribeComponent;
